import {DateTime} from "luxon";

export interface ModuleArPresetData {
  expiration_date: string;
  expiration_period_days: string;
  show_expiration_on_certificate: any;
  email_expiration_reminder: string;
  expiration_reminder_notice_in_days: string;
  expiration_reminder_notice_in_months: string;
  expiration_reminder_repeat_period_in_days: string;
  expiration_period_months: string;
  expiration_period_years: string;
  expiration_period_type?: any;
  expiration_reminder_to_student: string;
  expiration_reminder_to_manager: string;
  expiration_reminder_email_1?: any;
  expiration_reminder_email_2?: any;
  expiration_reminder_email_3?: any;
  expiration_reminder_email_4?: any;
  expiration_reminder_email_5?: any;
  round_expiration_date_up: string;
  expires: boolean;
  expiration_notify_status?: any;
  repeat_expiration_reminder: string;
  expiration_type: string;
  expiration_day_month?: any;
  expiration_day_month_type?: any;
  round_expiration_date_day: string;
  recurrent_status: any;
  recurrent_type: string;
  recurrent_frequency: string;
  recurrent_date: string;
  recurrent_date_every: string;
  recurrent_notify_period?: any;
  recurrent_notify_repeat_status: string;
  recurrent_notify_repeat: string;
  recurrent_notify_student: string;
  recurrent_notify_manager: string;
  recurrent_notify_instructor: string;
  recurrent_notify_custom?: any;
  auto_assign_status: string;
  auto_assign_course_status: string;
  auto_assign_courseID?: any;
  auto_assign_date_type: string;
  auto_assign_date_period: string;
  auto_assign_date_period_type: string;
  auto_assign_date: string;
  auto_assign_retain_month?: any;
  expiration_period: string;
  expiration_reminder_emails?: any;
  auto_assign_due_date_period: string;
  auto_assign_due_date_type: string;
  assignment_notify_student: string;
  assignment_notify_manager: string;
  assignment_notify_registrar: string;
  auto_assign_due_date_period_type: string;
  assignment_notify_custom: string;
  expiration_reminder_custom: string;
  valid_period_type: string;
  valid_period_length: string;
  valid_period_interval: string;
  valid_period_after: string;
  notifyArDueDate: string;
  notifyStudent: boolean;
  notifyManager: boolean;
  notifyCustom: boolean;
}

export var defaultModuleArPresetData: ModuleArPresetData = {
  expiration_date: '',
  expiration_period_days: '',
  show_expiration_on_certificate: 0,
  email_expiration_reminder: '',
  expiration_reminder_notice_in_days: '',
  expiration_reminder_notice_in_months: '',
  expiration_reminder_repeat_period_in_days: '',
  expiration_period_months: '',
  expiration_period_years: '',
  expiration_period_type: '',
  expiration_reminder_to_student: '',
  expiration_reminder_to_manager: '',
  expiration_reminder_email_1: '',
  expiration_reminder_email_2: '',
  expiration_reminder_email_3: '',
  expiration_reminder_email_4: '',
  expiration_reminder_email_5: '',
  round_expiration_date_up: '',
  expires: false,
  expiration_notify_status: '',
  repeat_expiration_reminder: '',
  expiration_type: '',
  expiration_day_month: '',
  expiration_day_month_type: '',
  round_expiration_date_day: '',
  recurrent_status: '',
  recurrent_type: '',
  recurrent_frequency: '',
  recurrent_date: '',
  recurrent_date_every: '',
  recurrent_notify_period: '',
  recurrent_notify_repeat_status: '',
  recurrent_notify_repeat: '',
  recurrent_notify_student: '',
  recurrent_notify_manager: '',
  recurrent_notify_instructor: '',
  recurrent_notify_custom: '',
  auto_assign_status: '',
  auto_assign_course_status: '',
  auto_assign_courseID: '',
  auto_assign_date_type: '',
  auto_assign_date_period: '',
  auto_assign_date_period_type: '',
  auto_assign_date: '',
  auto_assign_retain_month: '',
  expiration_period: '',
  expiration_reminder_emails: '',
  auto_assign_due_date_period: '',
  auto_assign_due_date_type: '',
  assignment_notify_student: '',
  assignment_notify_manager: '',
  assignment_notify_registrar: '',
  auto_assign_due_date_period_type: '',
  assignment_notify_custom: '',
  expiration_reminder_custom: '',
  valid_period_type: '',
  valid_period_length: '',
  valid_period_interval: '',
  valid_period_after: '',
  notifyArDueDate: '',
  notifyStudent: false,
  notifyManager: false,
  notifyCustom: false,
}

export enum PresetType {
    ModuleAutoRecurrent= 1
}

export interface PresetData {
    id: number;
    name: string;
    type: PresetType;
    data: Object;
    created: string | DateTime;
    modified: string | DateTime;
    networkId: number;
    creator: number;
    owner: number;
}

export interface PresetSaveData {
  id?: number;
  name: string;
  type: PresetType;
  data: string;
}

export class Preset implements PresetData {
    id: number;
    name: string;
    type: PresetType;
    data: Object;
    created: string | DateTime;
    modified: string | DateTime;
    networkId: number;
    creator: number;
    owner: number;

    constructor(type, presetData?: PresetData) {
        if (presetData) {
            Object.assign(this, presetData);

            this.data = JSON.parse(this.data as any);
        }
        else {
            this.name = '';
            this.data = {};
            this.owner = 0;
        }

        this.type = type;
    }

  getSaveData(data): string {
    let tempSaveObject: Object = {};
    let validKeys: string[]
    switch (this.type) {
      case PresetType.ModuleAutoRecurrent:
        validKeys = Object.keys(defaultModuleArPresetData);
        break;
    }
    validKeys.forEach(key => {
      if (data[key] !== undefined) {
        tempSaveObject[key] = data[key];
      }
      else {
        tempSaveObject[key] = '';
      }
    });
    return JSON.stringify(tempSaveObject);
  }
}
